module.exports = __webpack_public_path__ + "static/media/rebirth_sample_4.b08b62f7.jpg";